export const OffsetOnLoad = () => {
  if (window.innerWidth > 1160) {
    let carousels = document.querySelectorAll(".carousel-cont .carousel");
    let offset = (window.innerWidth - 1160) / 2;
    carousels.forEach((c) => {
      c.style.transform = `translateX(${offset}px)`;
    });
  } else {
    return false;
  }
};
